import React, { useEffect } from "react";
import { useConfig } from "@/contexts/ConfigContext";

export default function GoogleAd({ slot, className = "" }) {
  const { settings, loading } = useConfig();

  useEffect(() => {
    if (!loading && settings.ads_enabled === "true") {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense error", e);
      }
    }
  }, [loading, settings.ads_enabled]);

  if (loading || settings.ads_enabled !== "true") {
    return null;
  }

  const clientId = settings.ads_client_id;
  const slotId = slot || settings.ads_slot_id;

  return (
    <div className={`ad-container my-6 overflow-hidden flex flex-col items-center ${className}`}>
      <ins
        className="adsbygoogle"
        style={{ display: "block", minHeight: "100px", minWidth: "250px" }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
        data-adtest="on"
      ></ins>
      {/* Test Placeholder (Visible only if ad doesn't load or in development) */}
      <div className="w-full bg-secondary/30 border border-dashed border-border py-6 text-center text-[10px] uppercase tracking-widest text-muted-foreground font-bold">
        Ad Placement ({slotId})
      </div>
    </div>
  );
}
